module.exports = __webpack_public_path__ + "static/zero-trust-422245ef1247b5e42379b1ec5a3a89ff.png";